import { Component, OnInit, Input } from '@angular/core';
import { CmsService } from 'src/_service/CmsService';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { Card } from 'src/_model/storyblock';
import { CmsImageComponent } from "../cms-image/cms-image.component";
import { CmsButtonComponent } from "../cms-button/cms-button.component";

@Component({
    selector: 'app-cms-card',
    templateUrl: './cms-card.component.html',
    imports: [NgClass, NgTemplateOutlet, CmsImageComponent, CmsButtonComponent]
})
export class CmsCardComponent implements OnInit {

  cardbody: any
  cardTitle: any
  isTitleRichtext: boolean = false
  private _card: Card;
  @Input()set card (value: Card){
    this._card = value;
    this.cardbody = this._cmsService.render_rt(value.body)
    if (value.title) {
      if (typeof value.title === 'string') {
        this.cardTitle = value.title
        this.isTitleRichtext = false
      } else {
        this.cardTitle = this._cmsService.render_rt(value.title)
        this.isTitleRichtext = true
      }
    }
  }
  get card(){return this._card}
  video_url: any;
  video_html: any;

  @Input() removeMargin:boolean = false;

  constructor(private _cmsService: CmsService) {
  }


  ngOnInit() {
    
    if( !!this.card.vimeo_video?.vimeo_oembed?.response?.html ){
      if(this.card.vimeo_video?.vimeo_oembed?.response?.html.startsWith('<iframe src="')) {
        let player_src = this.card.vimeo_video?.vimeo_oembed?.response?.html.split('"')[1];
        if( !!this.card.auto_play_video) {
          player_src += '&background=1';
        }
        this.video_url = this.get_sanitized_url(player_src);
      } else {
        this.video_html = this._cmsService.get_sanitized_html(this.card.vimeo_video?.vimeo_oembed?.response?.html);
      }
    } else {
      if (this.card.video?.cached_url && this.card.video?.cached_url.startsWith('https://')) {
        this.video_url = this.get_sanitized_url(this.card.video.cached_url);
      }
    }
  }

  // render_rt(content) {
  //   return this._cmsService.render_rt(content);
  // }

  get_alt(field) {
    return this._cmsService.get_alt(field);
  }

  get_sanitized_url(url) {
    return this._cmsService.get_sanitized_url(url);
  }
  
  get_src(field, contain = null, height?, width?) {
    return this._cmsService.get_src(field, contain, height, width);
}

  get_classes(card) {
    return this._cmsService.get_classes(card);
  }

}
